import 'Styles/common.less';

import 'Components/main-content/main-content.less';
import 'Components/breadcrumbs/breadcrumbs.less';
import 'Components/card/card.less';
import 'Components/page-nav/page-nav.less';

//import 'babel-polyfill';
import 'WebComponents/greedy-nav';
//import 'WebComponents/adaptive-background';
import { A11y } from 'WebComponents/a11y';

const a11y = new A11y();
a11y.init();



// WEBPACK FOOTER //
// ./src/pages/news-list/index.js